var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout-section checkout-end" }, [
    _c(
      "div",
      { ref: "header" },
      [
        _vm.booking.type === "reserved"
          ? _vm._t("confirmationHeader-Reserved")
          : _vm._t("confirmationHeader"),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "checkout-end__success" }, [
          _c("div", { staticClass: "checkout-end__booking" }, [
            _c("div", { staticClass: "checkout-end__booking-details" }, [
              _c("h3", { staticClass: "checkout-end__booking-title" }, [
                _vm._v(
                  "Your booking reference is: " + _vm._s(_vm.bookingReference)
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "checkout-end__booking-tick" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "checkout-end__booking-description",
                domProps: {
                  innerHTML: _vm._s(_vm.confirmationType.descriptionHtml),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkout-end__booking-next-steps" }, [
              _c("h3", { staticClass: "checkout-end__booking-title" }, [
                _vm._v(_vm._s(_vm.confirmationType.nextStepsTitle)),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.confirmationType.nextStepsDescriptionHtml
                  ),
                },
              }),
              _vm._v(" "),
              _vm.confirmationType.nextStepsLink
                ? _c(
                    "a",
                    {
                      staticClass: "btn",
                      class: {
                        btn_Ts:
                          _vm.data.brandNameFormatted ===
                          _vm.Brand.Travelsphere,
                      },
                      attrs: { href: _vm.confirmationType.nextStepsLink.url },
                    },
                    [_vm._v(_vm._s(_vm.confirmationType.nextStepsLink.name))]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.booking
            ? _c(
                "div",
                {
                  staticClass: "checkout-end__summary",
                  class: {
                    "checkout-end__summaryTs":
                      _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
                  },
                },
                [
                  _c("h2", { staticClass: "checkout-end__summary-title" }, [
                    _vm._v(_vm._s(_vm.booking.tourName) + " - Summary"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "checkout-end__summary-section-wrapper" },
                    [
                      _vm.booking.flights.length
                        ? _vm._l(_vm.booking.flights, function (flight, index) {
                            return _c(
                              "div",
                              {
                                key: flight.carrierCode,
                                staticClass: "checkout-end__summary-section",
                              },
                              [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "checkout-end__summary-section-title",
                                  },
                                  [_vm._v("Flight " + _vm._s(index + 1))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Airline")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(flight.airline) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Departure airport")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(flight.departureAirport) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Departure date")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            flight.departureDate
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Departure time")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(flight.departureTime) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Arrival airport")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(flight.arrivalAirport) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Arrival date")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            flight.arrivalDate
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-end__info" },
                                  [
                                    _c("b", [_vm._v("Arrival time")]),
                                    _vm._v(
                                      "\n                  : " +
                                        _vm._s(flight.arrivalTime) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.startingLocation
                        ? _c(
                            "div",
                            { staticClass: "checkout-end__summary-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "checkout-end__summary-section-title",
                                },
                                [_vm._v("Starting location")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkout-end__info" }, [
                                _c("b", [_vm._v("Date")]),
                                _vm._v(
                                  "\n                : " +
                                    _vm._s(_vm.booking.startingLocation.date) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkout-end__info" }, [
                                _c("b", [_vm._v("Location")]),
                                _vm._v(
                                  "\n                : " +
                                    _vm._s(
                                      _vm.booking.startingLocation.location
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.finalLocation
                        ? _c(
                            "div",
                            { staticClass: "checkout-end__summary-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "checkout-end__summary-section-title",
                                },
                                [_vm._v("Final location")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkout-end__info" }, [
                                _c("b", [_vm._v("Date")]),
                                _vm._v(
                                  "\n                : " +
                                    _vm._s(_vm.booking.finalLocation.date) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkout-end__info" }, [
                                _c("b", [_vm._v("Location")]),
                                _vm._v(
                                  "\n                : " +
                                    _vm._s(_vm.booking.finalLocation.location) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "checkout-end__summary-section" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "checkout-end__summary-section-title",
                            },
                            [_vm._v("Passenger Names")]
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.booking.passengers,
                            function (passenger, passengerIndex) {
                              return _c(
                                "div",
                                {
                                  key: passenger.passengerId,
                                  staticClass: "checkout-end__info",
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("numberToWordsOrdinal")(
                                            passengerIndex + 1
                                          )
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                : " +
                                      _vm._s(_vm.passengerFullName(passenger)) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.booking.excursions.length
                        ? _c(
                            "div",
                            { staticClass: "checkout-end__summary-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "checkout-end__summary-section-title",
                                },
                                [_vm._v("Excursions")]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.booking.excursions,
                                function (excursion) {
                                  return _c(
                                    "div",
                                    {
                                      key: excursion.name,
                                      staticClass: "checkout-end__info",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(excursion.passengerCount) +
                                          " × " +
                                          _vm._s(excursion.name) +
                                          "\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("b", [_vm._v("Price")]),
                                      _vm._v(
                                        "\n                : " +
                                          _vm._s(
                                            _vm.currency(excursion.price)
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.visas.length
                        ? _c(
                            "div",
                            { staticClass: "checkout-end__summary-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "checkout-end__summary-section-title",
                                },
                                [_vm._v("Visas")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.booking.visas, function (visa) {
                                return _c(
                                  "div",
                                  {
                                    key: visa.id,
                                    staticClass: "checkout-end__info",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(visa.passengerCount) +
                                        " × " +
                                        _vm._s(visa.name) +
                                        "\n                "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("b", [_vm._v("Price")]),
                                    _vm._v(
                                      "\n                : " +
                                        _vm._s(_vm.currency(visa.price)) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "checkout-end__summary-section" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "checkout-end__summary-section-title",
                            },
                            [_vm._v("Payment and Balance")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _vm._v(
                              "\n                Total Price:\n                "
                            ),
                            _c("b", [
                              _vm._v(_vm._s(_vm.currency(_vm.booking.total))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _vm._v(
                              "\n                Amount paid:\n                "
                            ),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.currency(_vm.booking.amountPaid))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _vm._v(
                              "\n                Balance to pay:\n                "
                            ),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.currency(_vm.booking.balanceToPay))
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.booking.donations.length
                        ? _c(
                            "div",
                            { staticClass: "checkout-end__summary-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "checkout-end__summary-section-title",
                                },
                                [_vm._v("Thank you from Planeterra")]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.booking.donations,
                                function (donation) {
                                  return _c(
                                    "div",
                                    {
                                      key: donation.name,
                                      staticClass: "checkout-end__info",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(donation.passengerCount) +
                                          " × " +
                                          _vm._s(donation.name) +
                                          "\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("b", [_vm._v("Price")]),
                                      _vm._v(
                                        "\n                : " +
                                          _vm._s(_vm.currency(donation.price)) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }